module.exports = __webpack_public_path__ + "static/media/logo-copa-preta.efa0dc52.svg";